const AnexosListaSchema = () => ({
  title: 'Anexos (lista)',
  fieldsets: [
    { id: 'default', title: 'Default', fields: ['title', 'pageSize', 'limit'] },
  ],
  properties: {
    title: {
      title: 'Título',
      description: 'Título da seção (padrão: "Anexos")',
      default: 'Anexos',
    },
    pageSize: {
      title: 'Itens por página',
      type: 'integer',
      default: 25,
      description:
        'Quantos anexos exibir por página. Acima desse número, a lista ganha ' +
        'paginação e um campo para filtrar por nome. Listas menores continuam ' +
        'exibidas de uma vez, sem controles.',
    },
    limit: {
      title: 'Máximo de itens',
      type: 'integer',
      default: 400,
      description:
        'Teto de anexos carregados na página, somando todas as páginas da ' +
        'lista. Serve como salvaguarda; só precisa ser ajustado em contêineres ' +
        'com mais documentos do que esse valor.',
    },
  },
  required: [],
});

export default AnexosListaSchema;
